



















































import { Component } from 'vue-property-decorator';
import { ProductModel } from 'admiral-core';
import { PlusIcon, XIcon } from 'vue-feather-icons';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormMixin } from '@/mixins/FormMixin';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import { BModal } from 'bootstrap-vue';
import ProductForm from '@/forms/ProductForm.vue';
import { ProductApi } from '@/services/ProductApi';

@Component({
  components: {
    ProductForm,
    FormSubmit,
    PlusIcon,
    XIcon,
  },
})
export default class CreateProductModal extends mixins(FormMixin, BaseMixin) {
  model = this.defaultModel();

  defaultModel(): ProductModel {
    return {
      name: '',
    };
  }

  async mounted() {
    this.resetModel();
  }

  async ok(evt: Event) {
    evt.preventDefault();
    if (!this.model.name) {
      return;
    }
    try {
      this.isLoading = true;

      await ProductApi.create({
        name: this.model.name,
        agency: this.agency,
      });
      this.$toastr.s(`${this.model.name} erfolgreich angelegt.`, 'Produkt angelegt');
      this.$nextTick(() => {
        (this.$refs['create-product'] as BModal).hide();
      });

      this.$emit('reload');
      this.resetModel();
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern des Produkts ist etwas schief gelaufen.', 'Oops');
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(apiErrors['nameminLength'], 'name', 'Bitte einen gültigen Name angeben.');
  }

  cancel() {
    this.resetModel();
  }

  resetModel() {
    this.model = this.defaultModel();
  }

  reload() {
    //
  }
}
